import React from "react";
import ReactDOM from "react-dom/client";
import Website from "./website";
import "./website.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Website />
  </React.StrictMode>,
);
